import { ID, Url } from '../../utils/codecUtils';
import { membershipSchema } from '../models/membership.schema';
import { createMembershipPayloadSchema } from './create.schema';

export type CreateMembershipPayload = {
  user: Url;
  organization: Url;
  queues: Array<Url>;
};

export const create = (
  organizationGroupId: ID,
  payload: CreateMembershipPayload
) => {
  return {
    endpoint: `/organization_groups/${organizationGroupId}/memberships`,
    method: 'POST',
    responseSchema: membershipSchema,
    payloadSchema: createMembershipPayloadSchema,
    payload,
  } as const;
};
